import './style.scss'
import utility, { moneyFormat } from 'src/utils/utility'
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from 'src/provider/state-manager/userProvider';
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import { AbsoluteContainer, AddCardContainer, AppLabel, AppSpan, AppText, Button, Circle, CustomContainer, FixedContainer, FlexColumn, FlexRow, GridContainer, Icon, ScreenContainer, Switch } from 'src/style';
import { MakeTransfer, MakeTransferD3, Notification, RequestNewCardD3, Table, TransactionDetailsD3 } from 'src/component'
import {IoAdd, IoAddOutline, IoChevronBackOutline, IoChevronForwardOutline} from 'react-icons/io5'
import {MdAdd} from 'react-icons/md'
import {ReactComponent as BalanceTopIcon} from 'src/assets/img/balance-card-up-icon.svg'
import {ReactComponent as MastercardLogo} from 'src/assets/img/mastercard-logo.svg'
import {ReactComponent as MastercardLogoDark} from 'src/assets/img/mastercard-logo-dark.svg'
import cardMesh from 'src/assets/img/card-mesh.svg'
import cardWifi from 'src/assets/img/card-wifi.svg'
import FeedImg from 'src/assets/img/feed-img.svg'
import FeedBgImg from 'src/assets/img/feed-bg-img.svg'
import GreenCardBg from 'src/assets/img/green-card-bg.svg'
import PurpleCardBg from 'src/assets/img/purple-card-bg.svg'
// import {cardDetails, balanceDetails, dashboardInfo} from 'src/utils/mock-data'
import { transactionColumns, transactionData } from 'src/utils/tableLayout';
import helpers from 'src/utils/helpers';
import { Features, InstitutionProfileDCardData } from 'src/model';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import CopySVG from '../../../../../assets/svg/copy-icon'




export const HomeD3: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {user, setUserProperty} = useContext(UserContext)
    const {visibility, notifier} = useContext(VisibilityContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const [dashboardData, setDashboardData] = useState<any>(user.dashboardData)
    const [txData, setTxData] = useState<any>(null)
    const [cardData, setCardData] = useState<any[]>([])
    const [dataForCard, setDataForCard] = useState<InstitutionProfileDCardData | null>(null)
    const [acctTransactions, setAcctTransactions] = useState<any[]>([])
    const [balanceData, setBalanceData] = useState<any>(null)
    const [accountIndex, setAccountIndex] = useState(0)
    const [isHideBalance, setIsHideBalance] = useState(false)
    const [isTxDetails, setIsTxDetails] = useState(false)
    const [isTransfer, setIsTransfer] = useState(false)
    const [isCardRequest, setIsCardRequest] = useState(false)

    const date = user.userInfo?.profileInfo ? helpers.splitDateTime(user.userInfo?.profileInfo?.lastLoginDate) : null

    useEffect(() => {
        if (user.userInfo?.profileID) fetchDashboardData()
    }, [user.userInfo])

    useEffect(() => {
        if (user.dashboardData?.length) handleDataUpdate(user.dashboardData)
    }, [user.dashboardData])

    async function fetchDashboardData () {
        let response = await API.getDashboardData()
        if (response) {
            //response = dashboardInfo
            //handleDataUpdate(response)
        }
    }

    function handleDataUpdate (data: any) {
        if (data) {
            setDashboardData(data)
            setAcctTransactions(data[0].accountStatements)
            setCardData(data[0].cardDetail ? [data[0].cardDetail] : [])
            setBalanceData(data[0].accountBalance)
        }
    }

    function handleDashboardDataIndex (val: number) {
        setAccountIndex(val)
        setAcctTransactions(dashboardData[val].accountStatements)
        setCardData(dashboardData[val].cardDetail ? [dashboardData[val].cardDetail] : [])
        setBalanceData(dashboardData[val].accountBalance)
    }

    function handleTxDetails (data: any) {
        setTxData(data)
        setIsTxDetails(true)
    }

    async function handleViewAllTx () {
        await setUserProperty('recentTransactions', acctTransactions)
        navigate('/dashboard/transactions')
    }

    async function handleRequestCard () {
        const response = await API.getInstitutionInfoForCard()
        if (response) {
            setDataForCard(response)
            setIsCardRequest(true)
        }
    }

    return (
        <>
            <ScreenContainer padding='2.5' topPadding='0'>
                <CustomContainer
                    customRadius='28px 28px 0px 0px' borderColor='#EAECF0'
                    minHeight='100' mnHUnit='%' bgColor='#FCFCFC' padding='2'
                    className='d2-screen-bg-img'
                >
                    <CustomContainer>
                        <AppSpan textSize='2.2' fontWeight='700'>Hi {user.userInfo?.profileInfo?.firstName}!</AppSpan>
                        <FlexRow alignItems='center' topMargin='0.5' >
                            <AppText textSize='1.4' fontWeight='600' topMargin='0.5' rightMargin='1'>Account number: {user.userInfo?.profileInfo?.primaryAccount}</AppText>
                            <div
                                onClick={() => {
                                    if (user.userInfo?.profileInfo?.primaryAccount) {
                                        navigator.clipboard.writeText(user.userInfo.profileInfo.primaryAccount)
                                            .then(() => notifier.show('Account number successfully copied!','','success'))
                                            .catch(err => console.error("Failed to copy: ", err));
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                <CopySVG />
                            </div>
                        </FlexRow>                    </CustomContainer>
                    <FlexRow 
                        gap='2.5' justifyContent='space-between'
                        alignItems='stretch' topMargin='2'
                        className='balance-card-container'
                    >
                        <CustomContainer 
                            width='48.5' sizeUnit='%' minHeight='15.75'
                            className='acct-balance-container'
                        >
                            <CustomContainer 
                                width='100' sizeUnit='%' minHeight='7.3' bgColor='#0D968F'
                                padding='0.7' leftPadding='2' rightPadding='2'
                                style={{
                                    zIndex: '2', borderTopLeftRadius: '1rem', 
                                    borderTopRightRadius: '1rem', borderBottom: '0.2rem solid rgba(180, 227, 225, 1)'
                                }}
                            >
                                <AbsoluteContainer top='0' right='0'>
                                    <BalanceTopIcon />
                                </AbsoluteContainer>

                                <FlexRow 
                                    justifyContent={institutionData?.hideAvailableBalance ? 'flex-end' : 'space-between'}
                                    alignItems='flex-start'
                                >
                                    { !institutionData?.hideAvailableBalance &&
                                        <CustomContainer width='auto' sizeUnit=''>
                                            <AppLabel textSize='1.07' color='#ffffff'>Available balance</AppLabel>
                                            <AppText 
                                                textSize='1.7' fontWeight='700' color='#ffffff' 
                                                topMargin='-0.4' fontFamily='Gilmer-Bold'
                                            >
                                              {isHideBalance ? 'XXXXXXXXX' : moneyFormat(balanceData?.balance.availableBalance || 0, true,institutionData?.defaultCurrency)}
                                            </AppText>
                                        </CustomContainer>
                                    }
                                    <CustomContainer width='auto' sizeUnit=''>
                                        {
                                            isHideBalance ?
                                            <AppSpan 
                                                textSize='2.1' color='#ffffff' cursor='pointer' hoverColor='#A5A5A5'
                                                onClick={() => setIsHideBalance(!isHideBalance)}
                                            >
                                                <BsFillEyeSlashFill />
                                            </AppSpan>
                                            : 
                                            <AppSpan 
                                                textSize='2.1' color='#ffffff' cursor='pointer' hoverColor='#A5A5A5'
                                                onClick={() => setIsHideBalance(!isHideBalance)}
                                            >
                                                <BsFillEyeFill />
                                            </AppSpan>
                                        }
                                    </CustomContainer>
                                </FlexRow>
                            </CustomContainer>
                            <CustomContainer
                                width='100' sizeUnit='%' minHeight='6.5' 
                                padding='0.7' leftPadding='2' rightPadding='2'
                                bgColor='#1A2C37'
                                style={{zIndex: '2', borderBottomLeftRadius: '1rem', borderBottomRightRadius: '1rem'}}
                            >
                                <FlexRow 
                                    gap='1.5' wrap='wrap'
                                    justifyContent={institutionData?.hideWithdrawableBalance ? 'flex-end' : 'space-between'}
                                >
                                    { !institutionData?.hideWithdrawableBalance &&
                                        <CustomContainer width='auto' sizeUnit=''>
                                            <AppLabel textSize='1.07' color='#ffffff'>Withdrawable balance</AppLabel>
                                            <AppText 
                                                textSize='1.17' fontWeight='600' color='#ffffff' 
                                            >
                                               {isHideBalance ? 'XXXXXXXXX' : moneyFormat(balanceData?.balance.withdrawableAmount || 0, true, institutionData?.defaultCurrency)}
                                            </AppText>
                                        </CustomContainer>
                                    }
                                    <FlexRow width='auto' sizeUnit=''>
                                        <AppSpan 
                                            textSize='2.5' color='#ffffff' cursor='pointer' hoverColor='#A5A5A5'
                                            style={{visibility: accountIndex === 0 ? 'hidden' : 'visible'}}
                                            onClick={() => handleDashboardDataIndex(accountIndex - 1)}
                                        >
                                            <IoChevronBackOutline/>
                                        </AppSpan>
                                        <AppSpan 
                                            textSize='2.5' color='#ffffff' cursor='pointer' hoverColor='#A5A5A5'
                                            style={{visibility: (accountIndex + 1) === dashboardData?.length ? 'hidden' : 'visible'}}
                                            onClick={() => handleDashboardDataIndex(accountIndex + 1)}
                                        >
                                            <IoChevronForwardOutline/>
                                        </AppSpan>
                                    </FlexRow>
                                </FlexRow>
                            </CustomContainer>

                            <GridContainer>
                                <FlexRow gap="0.8" topMargin="0.7" width='auto' sizeUnit=''>
                                    { dashboardData?.length >= 2 &&
                                        dashboardData?.map((item: any, index: number) => {
                                            return (
                                                <Circle size="0.8" borderColor='#0D968F' bgColor={accountIndex === index ? "#0D968F" : '#ffffff'} key={index}/>
                                            )
                                        })
                                    }
                                </FlexRow>
                            </GridContainer>
                        </CustomContainer>
                        {/* CARDS */}
                        { institutionData.featureIDs?.includes(Features.CARDS) &&
                            <CustomContainer 
                                width='48.5' sizeUnit='%' minHeight='15.75'
                                className='acct-card-container'
                            >
                                <CustomContainer
                                    className='scrollable-container'
                                >
                                    <FlexRow gap='2' style={{minWidth: 'fit-content'}}>
                                        { cardData?.length >= 1 &&
                                            cardData?.map((item: any, index: number) => {
                                                let bgImg = index % 2 != 0 ? GreenCardBg : PurpleCardBg
                                                let color = '#ffffff' //index % 2 != 0 ? '#344054' : '#ffffff'
                                                let expiryDate = item.expiryDate ? helpers.getCardExpiryDate(item.expiryDate) : '00/00'

                                                return (
                                                    <CustomContainer 
                                                        width='22.3' radius='1.45' key={index} bgColor='#0D968F'
                                                        shadow='5.79747px 7.24684px 11.5949px rgba(0, 0, 0, 0.05)'
                                                    >
                                                        {/* <AbsoluteContainer top='0' left='0' height='full' width='100' sizeUnit='%'>
                                                            <Icon src={bgImg} noResize minWidth='100' style={{objectFit: 'cover'}} />
                                                        </AbsoluteContainer> */}
                                                        <AbsoluteContainer bottom='0' left='0' width='100' sizeUnit='%'>
                                                            <Icon src={cardMesh} noResize minWidth='100' style={{objectFit: 'cover'}} />
                                                        </AbsoluteContainer>
                                                        <AbsoluteContainer top='1.5' right='2'>
                                                            <CustomContainer width='1.5' height='2'>
                                                                <Icon src={cardWifi} minWidth='100' /> 
                                                            </CustomContainer>
                                                        </AbsoluteContainer>
                                                        
                                                        <FlexColumn 
                                                            minHeight='13.9' justifyContent='space-between' padding='1'
                                                            alignItems='flex-start' topPadding='1.5' bottomPadding='1.5'
                                                            style={{zIndex: '2'}}
                                                        >
                                                            <AppText textSize='1.16' fontWeight='600' color={color} fontFamily='Inter'>{institutionData?.name}</AppText>
                                                            <CustomContainer topMargin='2'>
                                                                <FlexRow width='auto' sizeUnit='' gap='5' bottomMargin='0.5'>
                                                                    <AppSpan textSize='0.87' color={color} fontWeight='600' fontFamily="Manrope">{item?.nameOnCard}</AppSpan>
                                                                    <AppSpan textSize='0.87' color={color} fontWeight='600' fontFamily="Manrope">{expiryDate}</AppSpan>
                                                                </FlexRow>
                                                                <AppText textSize='1.16' color={color} fontWeight='600' fontFamily="Manrope">{item?.cardPAN}</AppText>
                                                            </CustomContainer>
                                                            <AbsoluteContainer bottom='1.5' right='1'>
                                                                {index % 2 === 0 ? <MastercardLogoDark className='icon-component' /> : <MastercardLogo className='icon-component' />}
                                                            </AbsoluteContainer>
                                                        </FlexColumn>
                                                    </CustomContainer>
                                                )
                                            })
                                        }
                                        { cardData?.length <= 1 &&
                                            <GridContainer
                                                style={{width: cardData.length === 1 ? '18.5rem' : '100%' }} minHeight='13.9' bgColor='#ffffff'
                                                borderColor='#EAECF0' radius='0.8'
                                                onClick={handleRequestCard}
                                            >
                                                <AddCardContainer 
                                                    width='auto' sizeUnit='' 
                                                    // className='add-info-container'
                                                >
                                                    <AppSpan textSize='2' color='rgba(58, 58, 58, 0.58)'><MdAdd /></AppSpan>
                                                    <AppText textSize='1.2' color='rgba(58, 58, 58, 0.58)'>Add Card</AppText>
                                                </AddCardContainer>
                                            </GridContainer>
                                        }
                                    </FlexRow>
                                </CustomContainer>
                                <GridContainer>
                                    <FlexRow gap="0.8" topMargin="0.7" width='auto' sizeUnit=''>
                                        { cardData?.length >= 2 &&
                                            cardData?.map((item: any, index: number) => {
                                                return (
                                                    <Circle size="0.8" bgColor="#0D968F" key={index}/>
                                                )
                                            })
                                        }
                                    </FlexRow>
                                </GridContainer>
                            </CustomContainer>
                        }
                    </FlexRow>
                    <CustomContainer
                        borderColor='#EAECF0' radius='0.8' topMargin='3'
                        //shadow='0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)'
                    >
                        <FlexColumn minHeight='8' padding='2' alignItems='flex-start'>
                            <FlexRow justifyContent='space-between' gap='2' wrap='wrap'>
                                <AppText textSize='1.8' fontWeight='600' color='#101828'>Recent Transactions</AppText>
                                <Button
                                    width='8.5' height='4' bgColor='#ffffff'
                                    borderColor='#D0D5DD' color='#344054'
                                    hoverColor='#0D968F' titleSize='1.4'
                                    onClick={handleViewAllTx}
                                >
                                    View All
                                </Button>
                            </FlexRow>
                        </FlexColumn>
                        <Table
                            tableColumns={transactionColumns(handleTxDetails,institutionData?.defaultCurrency,isHideBalance)}
                            tableData={acctTransactions}
                            noDataText='No Transactions'
                            noRadius
                            customStyle
                            paginationPerPage={4}
                            noDataActionComponent={
                                (institutionData.featureIDs?.includes(Features.INTER_BANK_TRANSFER) || institutionData.featureIDs?.includes(Features.INTRA_BANK_TRANSFER)) ?
                                    <Button 
                                        width='16' height='4' topMargin='2' 
                                        borderColor='#0D968F' hoverBgColor='#fff' 
                                        hoverColor='#0D968F' titleSize='1.4'
                                        onClick={() => setIsTransfer(true)}
                                    >
                                        <IoAdd style={{marginRight: '0.5rem', fontSize: '2rem'}} />
                                        Send Money
                                    </Button>
                                    :
                                    null
                            }
                        />
                    </CustomContainer>
                    <CustomContainer topMargin='3' style={{overflow: 'hidden'}}>
                        <AppLabel textSize='1.8' fontWeight='600'>My Feeds</AppLabel>
                        { (!institutionData?.webActiveFeed || !institutionData?.webActiveFeed?.webImageUrl) ?

                            <>
                                <AbsoluteContainer top='1.5' left='50' lSizeUnit='%' >
                                    {/* <FeedImg /> */}
                                    <Icon src={FeedImg} noResize minWidth='100' style={{objectFit: 'cover'}} />
                                </AbsoluteContainer>
                                <FlexColumn 
                                    height='20.3' bgColor='#0D968F' radius='0.8' 
                                    alignItems='flex-start' padding='2' leftPadding='2.5' topMargin='1'
                                >
                                    <AbsoluteContainer top='0' left='0' height='full' width='100' sizeUnit='%'>
                                        <Icon src={FeedBgImg} noResize minWidth='100' style={{objectFit: 'cover'}} />
                                    </AbsoluteContainer>
                                    <AppText textSize='2.2' fontWeight='800' color='#ffffff' bottomMargin='0.5' fontFamily='Gilmer-Bold'>Refer a Friend</AppText>
                                    <AppSpan textSize='1.5' color='#ffffff'>To get access to N5000 voucher</AppSpan>
                                    <Button
                                        width='10.4' height='3.7' bgColor='#CDFFFC'
                                        color='#1A2C37' topMargin='4'
                                        hoverColor='#344054' titleSize='1.4'
                                    >
                                        See more
                                    </Button>
                                </FlexColumn>
                            </>
                            :
                            <CustomContainer 
                                maxHeight='21' radius='0.8' 
                                topMargin='1' height='21'
                                style={{overflow: 'hidden'}}
                                onClick={() => utility.handleFeedClick(institutionData.webActiveFeed.linkUrl)}
                            >
                                <img 
                                    src={institutionData.webActiveFeed.webImageUrl} 
                                    className='img-covered'
                                />
                            </CustomContainer>
                        }
                    </CustomContainer>
                </CustomContainer>
            </ScreenContainer>
            { isTxDetails &&
                <TransactionDetailsD3
                    data={txData}
                    nuban={balanceData?.nuban}
                    close={() => setIsTxDetails(false)} 
                />
            }
            { isTransfer &&
                <MakeTransferD3 
                    close={() => setIsTransfer(false)} 
                />
            }
            { isCardRequest &&
                <RequestNewCardD3
                    dataForCard={dataForCard}
                    close={() => setIsCardRequest(false)}
                />
            }
        </>
    );
}